import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const I_KEYBOARDING_ACTIVITY_FRAGMENT = gql `
  fragment IKeyboardingActivityFragment on IKeyboardingActivity {
    id
    title
    description
    category
    activityTypeVariantId
    activityTypeVariant {
      id
      name
      variant
      activityTypeId
      activityType {
        id
        name
        type
      }
      videos {
        device
        video {
          ...AssetFragment
        }
      }
    }
    productCurriculums {
      id
      name
      product {
        id
        name
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default I_KEYBOARDING_ACTIVITY_FRAGMENT;
